module.exports = __webpack_public_path__ + "img/2016_L.bbcc632c.png";